import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';
import { FormActions } from '../../componants/Workspace';

const EditSession = () => {
  const { id } = useParams();
  const { SetNotification } = useStateContext();
  const navigate = useNavigate();

  const titleRef = useRef(null);
  const descRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);
  const [conferenceId, setConferenceId] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await AxiosClient.get(`/sessions/${id}`);
        const s = response.data;
        titleRef.current.value = s.title || '';
        descRef.current.value = s.description || '';
        startRef.current.value = s.start_time ? s.start_time.replace(' ', 'T') : '';
        endRef.current.value = s.end_time ? s.end_time.replace(' ', 'T') : '';
        setIsActive(!!s.is_active);
        if (s.conference_id) setConferenceId(s.conference_id);
      } catch (error) {
        SetNotification('Error loading session', 'danger');
      } finally {
        setLoading(false);
      }
    };
    fetchSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const payload = {
      title: titleRef.current.value,
      description: descRef.current.value || null,
      start_time: startRef.current.value || null,
      end_time: endRef.current.value || null,
      is_active: isActive,
      conference_id: conferenceId,
    };

    try {
      const response = await AxiosClient.put(`/sessions/${id}`, payload);
      if (response.status === 200) {
        SetNotification('Session updated successfully', 'success');
        navigate(-1);
      }
    } catch (error) {
      const msg = error.response?.data?.message || 'Error updating session';
      SetNotification(msg, 'danger');
    }
    setIsSending(false);
  };

  if (loading) return <h6 className="m-3">loading ..</h6>;

  return (
    <div className="m-4">
      <ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />
      <form className="form-group" onSubmit={handleSubmit}>
        <h5>Session Title</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter title" ref={titleRef} required />
        </div>

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Enter description" ref={descRef} />
        </div>

        <h5>Start Time</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={startRef} />
        </div>

        <h5>End Time</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="datetime-local" className="form-control" ref={endRef} />
        </div>

        <div className="form-check mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="isActive"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isActive">Active</label>
        </div>

        <hr className="border-gray-300 my-4" />

        <FormActions>
          {isSending ? <span role="status">Saving session...</span> : (
            <button type="submit" className="btn btn-primary">Save changes</button>
          )}
        </FormActions>
      </form>
    </div>
  );
};

export default EditSession;
